/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderValidationData
 */
export interface ProviderValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderValidationData
     */
    label?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ProviderValidationData
     */
    providerIdentityCode?: ValidationMessage;
}

export function ProviderValidationDataFromJSON(json: any): ProviderValidationData {
    return ProviderValidationDataFromJSONTyped(json, false);
}

export function ProviderValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : ValidationMessageFromJSON(json['label']),
        'providerIdentityCode': !exists(json, 'providerIdentityCode') ? undefined : ValidationMessageFromJSON(json['providerIdentityCode']),
    };
}

export function ProviderValidationDataToJSON(value?: ProviderValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': ValidationMessageToJSON(value.label),
        'providerIdentityCode': ValidationMessageToJSON(value.providerIdentityCode),
    };
}


